import { render } from "./CapsTooltip.vue?vue&type=template&id=15d32920"
import script from "./CapsTooltip.vue?vue&type=script&lang=js"
export * from "./CapsTooltip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__